import React from 'react';
import Image from "next/image";
import Head from 'next/head';
import ImageFactory from '../../adapters/cloudinary/ImageFactory';
 
interface OptimizedImageProps {
  src: string | undefined;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  isBanner?: boolean;
  fill?: boolean;
  preload?: boolean;
  priority?: boolean;
  style?: React.CSSProperties;
  [key: string]: any;
}
 
const OptimizedImage = (props: OptimizedImageProps) => {
  const {
    src,
    alt = '',
    className,
    width,
    height,
    loading,
    fetchPriority,
    isBanner = false,
    fill,
    preload,
    priority,
    style,
    ...additionalProps
  } = props;
 
  if (!src) return null;
 
  const resolvedLoading = loading ?? (isBanner ? 'eager' : 'lazy');
  const resolvedFetchPriority = fetchPriority ?? (isBanner ? 'high' : undefined);
  const shouldPreload = preload ?? priority ?? isBanner;
 
  return (
    <>
      {shouldPreload && (
        <Head>
          <link
            rel="preload"
            href={src}
            as="image"
            fetchPriority="high"
          />
        </Head>
      )}
      <Image
        src={src}
        alt={alt}
        className={className}
        {...(!fill ? { width, height } : { fill: true })}
        sizes={isBanner ? '100vw' : "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"}
        style={style}
        loading={resolvedLoading}
        unoptimized
        fetchPriority={resolvedFetchPriority}
        {...additionalProps}
      />
    </>
  );
};
 
export default OptimizedImage;